module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-fa4d1aea!./packages/dof-status/colmo.css
// module id = 555
// module chunks = 0 1